<button id='register_new' type='button' class='btn btn-primary float-md-right' [disabled]="!harTilgangTilOpprettNy" routerLink="ny"><i class="fas fa-plus"></i> Registrer ny</button>

